export type HiringTrend =
  | 'rapidly-growing'
  | 'growing'
  | 'stable'
  | 'declining'
  | 'rapidly-declining';

export type HiringTrendReasonCode =
  | 'insufficient-data'
  | 'no-baseline'
  | 'rapidly-growing'
  | 'growing'
  | 'stable'
  | 'declining'
  | 'rapidly-declining';

export interface HiringTrendReasonInput {
  trend: HiringTrend;
  hasEnoughDataForTrends: boolean;
  recentAvg: number;
  earlierAvg: number;
  avgHeadcount: number | null;
}

export interface HiringTrendReason {
  code: HiringTrendReasonCode;
  changePercent: number | null;
  recentHiringRate: number | null;
  usedHeadcountAnalysis: boolean;
}

function safePercentChange(recentAvg: number, earlierAvg: number): number | null {
  if (earlierAvg <= 0) return null;
  return ((recentAvg - earlierAvg) / earlierAvg) * 100;
}

export function getHiringTrendReason(input: HiringTrendReasonInput): HiringTrendReason {
  const { trend, hasEnoughDataForTrends, recentAvg, earlierAvg, avgHeadcount } = input;
  const usedHeadcountAnalysis = avgHeadcount !== null && avgHeadcount > 0;
  const recentHiringRate = usedHeadcountAnalysis ? (recentAvg / avgHeadcount) * 100 : null;
  const changePercent = safePercentChange(recentAvg, earlierAvg);

  if (!hasEnoughDataForTrends) {
    return {
      code: 'insufficient-data',
      changePercent,
      recentHiringRate,
      usedHeadcountAnalysis,
    };
  }

  if (earlierAvg <= 0) {
    return {
      code: 'no-baseline',
      changePercent,
      recentHiringRate,
      usedHeadcountAnalysis,
    };
  }

  return {
    code: trend,
    changePercent,
    recentHiringRate,
    usedHeadcountAnalysis,
  };
}

